import { connect } from 'react-redux'

import { applyFilter } from '../../redux/modules/search/actions'

import Type from '../../components/filters/Type'

const mapStateToProps = (state) => ({
  types: state.search.filters.types || [],
  typeCounts: state.search.pagination.types || {},
})

const actionCreators = { applyFilter }

export default connect(mapStateToProps, actionCreators)(Type)



// WEBPACK FOOTER //
// ./src/containers/filters/Type.js